import DeviceTelemetry from './deviceTelemetry';

const deviceTelemetry = new DeviceTelemetry();

export default deviceTelemetry;
